import { Grid, Box, Button } from "@mui/material";
import { FC, useEffect, useState } from "react";
import { load, remove } from "../../constants/storage";
import DashboardNavbar from "../../components/DashboardNavbar";
import { H3, H4 } from "../../components/Typography";
import AddTicketModal from "../../components/AddTicketModal";
import { useNavigate } from "react-router-dom";
import CircularProgress from "@mui/material/CircularProgress";
import { toast } from "react-hot-toast";
import { createTickets,getSupport } from "../../redux/actions";
import { useAppDispatch } from "../../store/hooks";
import TicketsCard from "../../components/TicketsCard";

const Support: FC = () => {
  const dispatch = useAppDispatch();
  const [loading, setLoading] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [ticketType, setTicketType] = useState("Open");
  let navigate = useNavigate();
  const [openTicket, setOpenTicket] = useState([]);
  const [closeTicket, setCloseTicket] = useState([]);
  useEffect(() => {
    checkToken();
  }, []);

  const checkToken = async () => {
    let token = await load("token");
    if (token === undefined) {
      remove("userData");
      remove("token");
      toast.success("Session expired, please login again.");
      navigate("/login");
    } else {
      getTickets();
    }
  };

  const getTickets = async () => {
    setLoading(true);
    let userDetail: any = load("userData");
    let finalUser = JSON.parse(userDetail);
    let token = load("token");
    const values = {
      id: finalUser.id,
      mobile: finalUser.mobile,
      partner: finalUser?.refcode,
    };
    dispatch(getSupport(values, `bearer ${token}`))
      .then(async (response: any) => {
        setLoading(false);
        if (
          response?.message === "Support Id for user not found." ||
          response?.data?.length === 0
        ) {
          setOpenTicket([]);
          setCloseTicket([]);
          return;
        }
        const openTicket = response?.data?.filter(
          (item: any) => item.status.name !== "Closed"
        );

        setOpenTicket(openTicket);
        const closeTicket = response?.data?.filter(
          (item: any) => item.status.name === "Closed"
        );

        setCloseTicket(closeTicket);
      })
      .catch((error: any) => {
        setLoading(false);
      });
  };
  const handleOpenModal = () => {
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
  };

  const handleSave = (value: any) => {
    let token = load("token");
    let userDetail: any = load("userData");
    let finalUser = JSON.parse(userDetail);

    let categorieId =
      value.category === "Installation Crash"
        ? "1"
        : value.category === "Login/Account Issues"
        ? "2"
        : value.category === "KYC Issue"
        ? "3"
        : value.category === "KYC Re-initiate"
        ? "4"
        : value.category === "Fund Purchase Issue"
        ? "5"
        : value.category === "Fund Redemption Issue"
        ? "6"
        : value.category === "Piggy Bank Issue"
        ? "7"
        : "8";
    const req = {
      id: finalUser.id,
      mobile: finalUser.mobile,
      partner: finalUser?.refcode,
      tag_id: Number(categorieId),
      department_id: 1,
      priority_id: 1,
      status_id: 1,
      subject: value.subject,
      text: value.description,
    };

    dispatch(createTickets(req, `bearer ${token}`))
      .then(async (response: any) => {
        setLoading(false);  
        if (response?.statusCode == 200) {
          toast.success(response?.data?.message);
          handleCloseModal();
          getTickets();
          return;
        }
        if(response?.statusCode == 500){
          toast.error(response.message);
          handleCloseModal();
          return;
        }
        toast.error(response.message);
      })
      .catch((error: any) => {
        toast.error(JSON.stringify(error));
        setLoading(false);
        handleCloseModal();
      });
  };

  return (
    <>
      <DashboardNavbar />
      {loading ? (
        <Grid
          height="100vh"
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <CircularProgress />
        </Grid>
      ) : (
        <>
          <Grid
            sx={{
              pl: {
                md: 9,
                xs: 2,
                sm: 2,
              },
              pr: {
                md: 9,
                xs: 2,
                sm: 2,
              },
              pb: 10,
              pt: 2,
              alignItems: "center",

              display: "flex",
              flexDirection: "column",
              flex: 1,
              height: "100vh",
              background: "#E6E6E6",
            }}
          >
            <AddTicketModal
              open={openModal}
              handleClose={handleCloseModal}
              handleSave={handleSave}
              //nameValue={inputValue}
            />
            <Grid
              xs={12}
              sx={{
                background: "#FFFFFF",
                //p: 4,
                width: "100%",
                // alignItems: "center",
                //justifyContent: "center",
                display: "flex",
                flexDirection: "column",
                borderRadius: 2,
              }}
            >
              <Box
                sx={{
                  background: "#fff",
                  //p: 4,
                  width: "100%",
                  alignItems: "center",
                  //justifyContent: "center",
                  display: "flex",
                  flexDirection: "column",
                  borderRadius: 2,
                }}
              >
                <H4
                  sx={{
                    fontFamily: "'Poppins', sans-serif",
                    textAlign: "left",
                    width: "100%",
                    color: "#000",
                    p: 2,
                    ml: 5,
                  }}
                  fontWeight={"600"}
                >
                  Support
                </H4>
                <Button
                  type="submit"
                  size="medium"
                  sx={{
                    flexDirection: "row",
                    display: "flex",
                    alignItems: "center",
                    borderRadius: 2,
                    padding: 1,
                    paddingLeft: 2,
                    color: "#fff",
                    paddingRight: 2,
                    marginTop: 0.5,
                    background: process.env.REACT_APP_BUTTON_GRADIENT_COLOR,
                    fontSize: 14,
                    position: "relative",
                    justifyContent: "center",
                    width: {
                      md: "25%",
                      xs: "80%",
                    },
                    mb: 2,
                    mt: 2,
                  }}
                  onClick={handleOpenModal}
                >
                  Create Ticket
                </Button>
              </Box>
              <Box
                sx={{
                  width: "100%",
                  borderRadius: 2,
                  pb: 1,

                  display: "flex",
                  flexDirection: "row",
                }}
              >
                <Button
                  onClick={() => {
                    setTicketType("Open");
                  }}
                  disableElevation
                  disableRipple
                  size="medium"
                  sx={{
                    background:
                      ticketType === "Open"
                        ? process.env.REACT_APP_BUTTON_ACTIVE_COLOR
                        : "#F6F6F6",
                    color: ticketType === "Open" ? "#fff" : "#000",
                    width: "50%",
                    borderBottomRightRadius: 0,
                    borderTopRightRadius: 0,
                    borderTopLeftRadius: 0,
                    borderBottomLeftRadius: 0,
                    pt: 1.5,
                    pb: 1.5,
                    "&:hover": {
                      background:
                        ticketType === "Open"
                          ? process.env.REACT_APP_BUTTON_ACTIVE_COLOR
                          : "#F6F6F6",
                    },
                  }}
                >
                  Open Tickets
                </Button>
                <Button
                  disableElevation
                  disableRipple
                  onClick={() => {
                    setTicketType("Close");
                  }}
                  size="medium"
                  sx={{
                    background:
                      ticketType === "Close"
                        ? process.env.REACT_APP_BUTTON_ACTIVE_COLOR
                        : "#F6F6F6",
                    color: ticketType === "Close" ? "#fff" : "#000",
                    width: "50%",
                    borderTopLeftRadius: 0,
                    borderBottomLeftRadius: 0,
                    borderBottomRightRadius: 0,
                    borderTopRightRadius: 0,
                    "&:hover": {
                      background:
                        ticketType === "Close"
                          ? process.env.REACT_APP_BUTTON_ACTIVE_COLOR
                          : "#F6F6F6",
                    },
                  }}
                >
                  Closed Tickets
                </Button>
              </Box>
              {ticketType === "Open" &&
                (openTicket.length === 0 ? (
                  <Grid
                    display="flex"
                    flexDirection="column"
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      mt: 30,
                      mb: 30,
                    }}
                  >
                    <H3>No Tickets!</H3>
                  </Grid>
                ) : (
                  <Box
                    sx={{
                      width: "96%",
                      p: 3,
                      alignSelf: "center",
                    }}
                  >
                    {openTicket?.map((item: any) => (
                      <TicketsCard data={item} status={"Open"} />
                    ))}
                  </Box>
                ))}
              {ticketType === "Close" &&
                (closeTicket.length === 0 ? (
                  <Grid
                    display="flex"
                    flexDirection="column"
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      mt: 30,
                      mb: 30,
                    }}
                  >
                    <H3>No Tickets!</H3>
                  </Grid>
                ) : (
                  <Box
                    sx={{
                      width: "96%",
                      p: 3,
                      alignSelf: "center",
                    }}
                  >
                    {closeTicket?.map((item: any) => (
                      <TicketsCard data={item} status={"Close"} />
                    ))}
                  </Box>
                ))}
            </Grid>
          </Grid>
        </>
      )}
    </>
  );
};

export default Support;

